
      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire0300"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire0300"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

var $4AGbv = parcelRequire("4AGbv");

var $iNA1s = parcelRequire("iNA1s");
// Register ScrollTrigger
(0, $4AGbv.default).registerPlugin((0, $iNA1s.ScrollTrigger));
document.addEventListener("DOMContentLoaded", ()=>{
    (0, $4AGbv.default).set(".footer-container span", {
        opacity: 0,
        x: -100
    });
    (0, $4AGbv.default).set(".footer-container img", {
        opacity: 0,
        x: 100
    });
    (0, $4AGbv.default).to(".footer-container span", {
        x: 0,
        duration: 1,
        opacity: 1,
        ease: "power3.inout",
        stagger: 0.3,
        scrollTrigger: {
            trigger: ".footer",
            start: "top bottom-=10%",
            toggleActions: "play none none reverse"
        }
    });
    (0, $4AGbv.default).to(".footer-container img", {
        x: 0,
        duration: 1,
        opacity: 1,
        ease: "power3.inout",
        stagger: 0.3,
        scrollTrigger: {
            trigger: ".footer",
            start: "top bottom-=10%",
            toggleActions: "play none none reverse"
        },
        onComplete: function() {
            (0, $4AGbv.default).set(".footer-container img", {
                clearProps: "all"
            }); // Removes inline styles so CSS animations work again
        }
    });
});


//# sourceMappingURL=index.752d914b.js.map
